import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { MiViewColors, MiViewFontSize } from 'miview-ui/miviewTheme';

export const accordionHeaderStyle: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '2px',
  padding: '8px 16px',
  background: 'linear-gradient(to right, rgb(223, 223, 223), rgb(255, 255, 255))',
  borderBottom: `1px solid ${MiViewColors.softGray}`,
  fontSize: MiViewFontSize.small,
};

export const infoBoxStyle: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
};

export const percentBlockStyle: SxProps<Theme> = {
  background: MiViewColors.vividOrange,
  borderRadius: '20px',
  padding: '2px 8px',
  marginRight: '4px',
  fontSize: MiViewFontSize.small,
  color: MiViewColors.tertiary,
  width: 'max-content',
  display: 'flex',
  alignItems: 'center',
};
